module.exports = __webpack_public_path__ + "img/delete-box-red.fb278426.svg";